import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import AppWrapper from './AppWrapper';
// import registerServiceWorker from "./registerServiceWorker";

// require("dotenv").config();

ReactDOM.render(
  <AppWrapper>
    <App />
  </AppWrapper>,
  document.getElementById('root')
);
// registerServiceWorker(); // This caching enables use of the site when offline or when internet is slow.



// WEBPACK FOOTER //
// ./src/index.js